const cache = require('js-cache');

export class Cache {
  cache: any;
  maxsize: number;
  constructor(maxsize: number) {
    this.cache = new cache();
    this.maxsize = maxsize;
  }

  set(key: string, value: any) {
    const cacheValue = {
      value,
      date: new Date(Date.now()),
    };
    if (this.cache.size() > this.maxsize) {
      let minDate = new Date(8640000000000000); //the maximum date in ECMAScript
      let minKey = '';
      this.cache.keys().map((key: string) => {
        const val = this.cache.get(key);
        if (val.date < minDate) {
          minDate = val.date;
          minKey = key;
        }
      });
      this.cache.del(minKey);
    }
    this.cache.set(key, cacheValue, 900000); //cached for 15 minutes
  }
  get(key: string) {
    const value = this.cache.get(key);
    if (!value) return value;
    value.date = new Date(Date.now());
    this.cache.set(key, value);
    return value.value;
  }

  del(key: string) {
    return this.cache.del(key);
  }

  clear() {
    return this.cache.clear();
  }

  getCache() {
    return this.cache.keys();
  }
}
